import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import it from './lang/it.json'
import en from './lang/en.json'
import es from './lang/es.json'
import de from './lang/de.json'

i18n
    .use(initReactI18next)
    .init({
        resources: {
            it: {
                translation: it
            },
            en: {
                translation: en
            },
            es: {
                translation: es
            },
            de: {
                translation: de
            }
        },
        lng: 'it',
        fallbackLng: 'it',
        keySeparator: '.',
        interpolation: {
            escapeValue: false
        }
    })

export default i18n
